interface MachineMismatchBannerProps {
  productName?: string;
  className?: string;
}

/**
 * Banner shown when licensing check returns MACHINE_MISMATCH.
 * Instructs user they are on a different device and to contact admin.
 */
export function MachineMismatchBanner({ productName, className = '' }: MachineMismatchBannerProps) {
  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-lg border border-amber-500/50 bg-amber-500/10 p-4 text-amber-800 dark:text-amber-200 ${className}`}
    >
      <span className="text-amber-600 dark:text-amber-400" aria-hidden>
        ⚠
      </span>
      <div className="min-w-0 flex-1">
        <p className="font-medium">
          Bạn đang dùng máy khác so với máy đã đăng ký
          {productName ? ` cho "${productName}"` : ''}.
        </p>
        <p className="mt-1 text-sm opacity-90">
          Để sử dụng sản phẩm trên thiết bị này, vui lòng liên hệ quản trị viên để cập nhật
          thiết bị được phép.
        </p>
      </div>
    </div>
  );
}
